import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import Button from '../button/button';
import Icon from '../icon/icon';
import { NavebarButtonsStyles } from './navBar.styles';
import { useAuthContext } from './../../../context/AuthContext';
import { Typography } from '@mui/material';
import commonConstants from '../../../constants/commonConstants';

export default function AccountButton({ isAuthenticated, isSmallMobile, item }) {
  const { isAuthorized, signout } = useAuthContext();
  // Create desktop menu item components based on ACF custom metadata
  const createDesktopNavComponent = {
    button: (props, customStyle = {}) => <Button
      color={props.background_color}
      size={props.size}
      sx={{
        ...customStyle
      }}
      onClick={() => {
        if(props?.url === commonConstants.SIGN_OUT_URL) {
          signout();
        }
        window.location.href = props?.url || '/';
      }}
      variant={props?.button_variant}
    >
      {props.title}
    </Button>,
    typography: (props) => (
      <Typography fontFamily={props?.fontfamily} fontStyle={props?.fontstyle} fontWeight={props?.fontweight}>
        {props?.add_html_content ?
          <div dangerouslySetInnerHTML={{ __html: props.html_content }} /> :
          props?.text_content}
      </Typography>
    ),
    icon: (props) => <Icon type={props?.custom_icon} fontSize="medium" color="#11728D" />,
    iconButton: (props) => {
      if (props?.custom_icon) {
        return <Button
          color={
            props.background_color === "text" ? "#000000" : props?.background_color
          }
          fontFamily="body.fontFamily.secondary"
          fontWeight="400"
          variant={props?.button_variant}
          onClick={() => {
            if(props?.url === commonConstants.SIGN_OUT_URL) {
              signout();
            }
            window.location.href = props?.url;
          }}
          sx={{
            fontSize: { xs: "13px", lm: "16px" },
            my: 2,
            display: "flex",
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '&:hover':{
              background:"transparent"
            }
          }}
        >
          <Box sx={{ px: "10px" }}>
            <Icon
              color={
                props.background_color === "text" ? "#000000" : props?.background_color
              }
              sx={{
                fontSize: isSmallMobile ? '13px' : '16px',
              }}
              type={props?.custom_icon}
            />
          </Box>
          {props?.title}
        </Button>
      }
      return null;
    },

  };

  return (
    <Box sx={{ flexGrow: 0, mr: { xs: '20px', lg: 0 } }}>
      {(item?.acf.isbutton && item?.acf.custom_icon === 'Select Icon') ? createDesktopNavComponent.button(item?.acf, {
        py: 2,
        my: 2,
        display: "block",
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }) : ((item?.acf.isbutton && item?.acf.custom_icon !== 'Select Icon') ? createDesktopNavComponent.iconButton(item?.acf) : createDesktopNavComponent.typography(item?.acf))}
    </Box>
  );
}

AccountButton.propTypes = {
  isAuthenticated: PropTypes.bool,
  isSmallMobile: PropTypes.bool,
};
